module.exports = require("./de-IT.d.ts");